<!-- Настраивает общую навигационную карточку для быстрых действий главной страницы. -->
<template>
  <BaseNavigationCard
    :label="label"
    :description="description"
    :color="color"
    :icon-background="iconBackground"
    :icon-name="iconName"
    :with-arrow="withArrow"
    :list-to="listTo"
    :list-label="listLabel"
    :list-action-text="listActionText"
    :list-subject="listSubject"
    @click="$emit('click')"
  />
</template>

<script>
export default {
  name: "HomeQuickActionCard",

  props: {
    label: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      required: true,
    },
    iconBackground: {
      type: String,
      default: "",
    },
    iconName: {
      type: String,
      required: true,
    },
    withArrow: {
      type: Boolean,
      default: true,
    },
    listTo: {
      type: [Object, String],
      default: null,
    },
    listLabel: {
      type: String,
      default: "Открыть список",
    },
    listActionText: {
      type: String,
      default: "Открыть",
    },
    listSubject: {
      type: String,
      default: "",
    },
  },

  emits: ["click"],
};
</script>
